<template>
    <div>
        <h2>{{$t('labels.netWork')}}</h2>
        <div class="row">
            <div class="col" v-for="(stats, index) in this.data" :key="index">
                <div v-if="index==0">
                    <img src="@/assets/images/business-operations/wifi.svg" alt=""> 
                    <div class="counter" :data-number="stats.number"></div>
                    <span class="font-weight-bolder font">{{stats.number}}</span>
                    <br/>
                    {{stats.title}}
                </div>
                <div v-if="index!=0">
                    <Progress :radius="50" :strokeWidth="20" :value="stats.number">
                    </Progress>
                    <div class="title">
                        {{stats.title}}
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
    import Progress from "easy-circular-progress";
    import util from '@/mixin/util';
    export default {
        props:{
            data: Array
        },
        mixins:[util],
        components:{
            Progress
        },
        mounted(){
            this.counterAnimation();
        }
    }
</script>

<style lang="scss" scoped>
    /deep/{
        
        .circle{
            &__progress{
                stroke: rgb(82, 185, 233) !important;
            }
        }
        .circle__progress{
            stroke-linecap: revert;
            &--path{
                stroke: rgb(225, 226, 227) !important;
            }
        }
        .vue-circular-progress .percent__int{
            font-size:rem(22px);
            stroke-opacity: 1;
        }
        .vue-circular-progress {
            .percent{
                .dot , &__dec{
                    display:none;
                }
            }
            .circle__progress{
                stroke-linecap: revert !important;
            }
        }
    }
    h2{
        font-weight:900;
        margin:rem(30px) 0;
        color:#414042;
    }
    .font{
        font-size: 30px;
    }
    .row{
        align-items:center;
        margin-bottom:rem(70px);
        @media screen and (max-width:991px){
            margin-bottom:rem(40px);
        }
        .col{
            text-align:center;
            font-weight:700;
            color:#414042;
            line-height:1.3;
            img{
                margin-bottom:20px;
                max-width: 100px;
            }
            .counter{
                text-align: center;
                font-size:rem(30px);
                font-weight:900;
                margin-bottom:5px;
                color:#414042;
                @media screen and (max-width:991px){
                    font-size:rem(22px);
                }
            }
            .title{
                font-weight:700;
                color:#414042;
            }
        }
        @media screen and (max-width:991px){
            >div{
                max-width:33.3%;
                flex:0 0 33.3%;
                margin-bottom:rem(25px);
            }
        }
        @media screen and (max-width:575px){
            >div{
                max-width:50%;
                flex:0 0 50%;
            }
        }
    }
</style>